import respinos from "../../../../assets/img/logo/Logo Respinos 5.png";
import Button from "../Button/Button";

const DeviceInfo = (props) => {
  if (props.device._id === undefined)
    return (
      <div
        className={`border border-primary shadow-lg rounded-lg px-2 md:px-4 py-1 md:py-3 animate-pulse flex space-x-3 ${props.className}`}
      >
        <div className="rounded-full bg-primary h-12 w-12"></div>
        <div className="flex-1 space-y-2 py-1">
          <div className="h-4 bg-primary rounded w-5/6"></div>
          <div className="h-4 bg-primary rounded"></div>
        </div>
      </div>
    );
  return (
    <div
      className={`border border-primary shadow-lg rounded-lg px-2 md:px-4 py-1 md:py-3 ${props.className}`}
    >
      <div className="flex justify-between relative">
        <div className="flex space-x-4 items-center py-1 ">
          <div className="w-10 md:w-12 h-10 md:h-12 flex-shrink-0">
            <img src={respinos} className="" />
          </div>
          <div className="">
            <div className="text-lg md:text-xl font-medium">
              {props.device._id}
            </div>
            <div className="text-sm text-gray-800 text-opacity-50 flex space-x-2 mt-0 md:mt-1">
              {!props.device.isReady ? (
                <div className="inline-block bg-gray-400 text-white rounded-full px-2">
                  inactive
                </div>
              ) : (
                <div className="inline-block bg-primary text-white rounded-full px-2">
                  active
                </div>
              )}
              <div className="">
                {props.device.doctor && (
                  <div>
                    {props.device.doctor.name || ""}
                    <span className="hidden sm:inline-block">
                      - {props.device.doctor.profile.workingPlace}{" "}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="absolute right-0">
            <Button
              className="text-xs md:text-sm text-center leading-tight bg-primary text-white px-2 py-1 rounded-lg shadow-lg "
              handleClick={() => {
                if (props.handleClick) props.handleClick();
              }}
            >
              <div>Gunakan</div>
              <div>Perangkat</div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DeviceInfo;
